import { AuthState, JobState, State } from "../types";

export interface AbortJobAction {
  jobId: string;
  type: "ABORT JOB";
}
export const abortJob = (state: State, action: AbortJobAction): State => {
  if (state.auth.state !== AuthState.loggedIn) {
    return state;
  } else if (!(action.jobId in state.jobs)) {
    return state;
  }
  let job = state.job;
  if (
    (job.state === JobState.loading && job.jobId === action.jobId) ||
    (job.state === JobState.ready && job.job.id === action.jobId)
  ) {
    job = { jobId: action.jobId, state: JobState.aborted };
  }
  return {
    ...state,
    job,
    jobs: {
      ...state.jobs,
      [action.jobId]: {
        ...state.jobs[action.jobId],
        override: {
          ...state.jobs[action.jobId].override,
          claimed_by: null,
        },
      },
    },
  };
};
